<template>
    <div class="verify-modal-overlay">
        <div class="verify-modal">
            <h2>Verify Molecule #{{ item.index + 1 }}</h2>

            <div class="verify-notice">
                <strong>Important:</strong> This shows if the computer
                correctly "read" your drawing. If they match, click "Keep".
                If not, click "Redraw".
            </div>

            <div class="verify-comparison">
                <div class="verify-column">
                    <h3>Your Drawing</h3>
                    <div class="verify-preview">
                        <img
                            :src="item.thumbnail"
                            alt="Your drawing"
                        />
                    </div>
                </div>

                <div class="verify-column">
                    <h3>Computer's Interpretation</h3>
                    <div class="verify-preview verify-rdkit">
                        <div v-if="!molecule" class="verify-loading">
                            Unable to detect molecule structure
                        </div>
                        <MoleculeStructure
                            v-else
                            :key="molecule"
                            :id="`structure-svg`"
                            :structure="molecule"
                            :width="300"
                            :height="300"
                            svg-mode
                        ></MoleculeStructure>
                    </div>
                </div>
            </div>

            <div class="verify-actions">
                <button @click="$emit('keep')" class="btn-keep">
                    Looks Good - Keep
                </button>
                <button @click="$emit('redraw')" class="btn-redraw">
                    Doesn't Match - Redraw
                </button>
            </div>

            <button @click="$emit('cancel')" class="btn-cancel">
                Cancel
            </button>
        </div>
    </div>
</template>

<script setup>
import MoleculeStructure from '../MoleculeStructure.vue';

defineProps({
    item: {
        type: Object,
        required: true
    },
    molecule: String
});

defineEmits(['keep', 'redraw', 'cancel']);
</script>

<style scoped>
.verify-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 20px;
}

.verify-modal {
    background: var(--bg-primary);
    border: 2px solid var(--accent);
    padding: 30px;
    max-width: 900px;
    width: 100%;
    max-height: 90vh;
    overflow: auto;
}

.verify-modal h2 {
    color: var(--text-secondary);
    margin-bottom: 20px;
    font-size: 24px;
}

.verify-notice {
    background: var(--bg-secondary);
    padding: 15px;
    margin-bottom: 20px;
    border: 1px solid var(--accent);
    font-size: 14px;
    line-height: 1.6;
    color: var(--text-primary);
}

.verify-comparison {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 30px;
}

.verify-column h3 {
    color: var(--text-secondary);
    font-size: 16px;
    margin-bottom: 10px;
    text-align: center;
}

.verify-preview {
    border: 2px solid var(--accent);
    background: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 300px;
}

.verify-preview img,
.verify-preview svg {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.verify-rdkit {
    background: #fff;
}

.verify-loading {
    color: #666;
    font-size: 14px;
    text-align: center;
    padding: 20px;
}

.verify-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
}

.btn-keep {
    padding: 15px;
    background: #4caf50;
    color: white;
    border: none;
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
}

.btn-redraw {
    padding: 15px;
    background: #f44336;
    color: white;
    border: none;
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
}

.btn-cancel {
    margin-top: 15px;
    padding: 12px;
    background: transparent;
    color: var(--text-secondary);
    border: 2px solid var(--accent);
    cursor: pointer;
    width: 100%;
    font-size: 14px;
}
</style>